module.exports = __webpack_public_path__ + "static/media/09B.e818851d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/robots/09B.png
// module id = 266
// module chunks = 0